import { render, staticRenderFns } from "./TopStudent.vue?vue&type=template&id=7c288c0f&"
import script from "./TopStudent.vue?vue&type=script&lang=js&"
export * from "./TopStudent.vue?vue&type=script&lang=js&"
import style0 from "./TopStudent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
